import required from "vuelidate/lib/validators/required";
import isCepValid from "@utils/is-cep-valid";

import FieldText from "@components/molecules/m-field-text.vue";

export default {
  component: FieldText,
  slot: {
    component: "button",
    content: "Não sei o CEP da minha empresa",
    onClick: () => {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: "consultar-cep",
          "content-name": "botao-consultar-cep",
        });
      }
    },
    attrs: {
      type: "button",
      class: [
        "text-left",
        "underline",
        "cursor-pointer",
        "text-dark-100",
        "mt-1",
        "opacity-75",
        "text-xs",
        "outline-none",
        "focus:outline-none",
      ],
    },
  },
  attrs: {
    label: "CEP",
    name: "cep",
    class: ["cep"],
    mask: ["#####-###"],
    placeholder: "Informe seu CEP",
    type: "tel",
    required: true,
  },
  errorMessages: [
    {
      name: "required",
      message: "É preciso informar o CEP do local.",
    },
    {
      name: "isCepValid",
      message: "O cep está incorreto!",
    },
  ],
  validation: {
    required,
    isCepValid,
  },
};
